export default __webpack_public_path__ + "static/media/scripts.cfcd9290.svg";